export default __webpack_public_path__ + "static/media/excro-logo.c0b34d36.svg";